import type {NextPage} from "next";

const Page: NextPage = () => {
  return (
    <div className="">
      {/* <Navbar backgroundColor="white" /> */}
      <div className="flex flex-col lg:px-52 px-4 pt-8 gap-8">
        {/* <div
          className="pt-16 rounded-md"
          style={{ backgroundColor: "#617DDE" }}
        >
          <TandCImage />
        </div> */}
        <form className="grid  gap-16 xl:gap-8 mt-8 mb-8">
          <div className="text-4xl xl:text-6xl">{`Privacy Policy`}</div>
          <div className="flex flex-col gap-8 xl:p-8 w-full bg-white rounded-md col-span-1 leading-relaxed text-dark-gray">
            <div>
              <div>
                {`Protecting your privacy is important to us. We hope the 
                following statement will help you understand how our Collage 
                Maker app deals with the personally identifiable information 
                ('PII') you may occasionally provide to us via the Internet.`}
              </div>
              <br/>

              <div>
                {`Generally, we do not collect any PII from you when you download 
                our applications. To be specific, we do not require the consumers 
                to get registered before downloading the application, nor do we 
                keep track of the consumers' visits to our application, we even 
                don't have a Server to store such PII.`}
              </div>
              <br/>

              <div>
                {`Our MixCollage Collage Maker app will never collect and store any face data 
                when you use our application. And any PII can not be shared with 
                any third parties.`}
              </div>
              <br/>

              <div>
                {`The only situation we may get access to your PII is when you personally 
                decide to email us your feedback or to provide us with a bug report. 
                The PII we may get from you in that situation is strictly limited to 
                your name, email address, and your survey response only.`}
              </div>
              <br/>

              <div>
                {`In the above situation, we guarantee that your PII will only be used 
                for contacting you and improving our services. We will never use such 
                information (e.g. your name and email address) for any other purposes, 
                such as to further market our products or to disclose your personal 
                information to a third party for commercial gains.`}
              </div>
              <br/>
              
              <div>
                {`It should be noted that whether or not to send us your feedback or bug 
                report is a completely voluntary initiative upon your own decision. 
                If you have a concern about your PII being misused, or if you want 
                further information about our privacy policy and what it means, 
                please feel free to email us in “Setting”- “Feedback”, we will 
                endeavor to provide clear answers to your questions in a timely manner.`}
              </div>
              <br/>

              <div>
                {`In addition, you can revoke the MixCollage Collage Maker app’s access to your data 
                via the Google security settings page at `}
                <a href="https://myaccount.google.com/permissions" className="text-blue">
                  {`https://myaccount.google.com/permissions`}</a>
              </div>
              <br/>

              <div>
                {`Our app uses Admob as an ad provider. The advertising providers want 
                to show ads that are relevant to you. For more information, please check`}
              </div>

              <div>
                <div style={{paddingLeft: 48}}>
                  <ol style={{ listStyleType: 'decimal'}}>
                    <li><a href="http://www.facebook.com/privacy/explanation" className="text-blue">
                      {`http://www.facebook.com/privacy/explanation`}</a></li>
                    <li><a href="https://support.google.com/admob/answer/6128543?hl=en" className="text-blue">
                      {`https://support.google.com/admob/answer/6128543?hl=en`}</a></li>
                  </ol>
                </div>
              </div>

              <div>
                {`With your permission, the advertising providers may use personal data to enhance your advertising experience.`}
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* <Footer backgroundColor="#FAFAFA" textColor="black" titleColor="black" /> */}
    </div>
  );
};

export default Page;
